module.exports = __webpack_public_path__ + "img/1513931391.4a73956d.jpg";